import React from 'react';
import { snakkerVerbs } from '../../data/proposal';
export function IdeaPanel() {
  return <div data-id="element-87" data-mp="3k3ezq52typj7">
      <h2 className="max-w-3xl text-[36px] font-medium leading-[1.04] tracking-[-0.035em] text-navy md:text-[48px]" data-id="element-88" data-mp="3k3nbtur4pqtc">
        Don't just tell the product story. Let the HCP experience it.
      </h2>
      <p className="mt-6 max-w-2xl text-lg leading-relaxed text-navy/65" data-id="element-89" data-mp="3a6is01kra7fp">
        Product benefits in pharma are often communicated through explanation: claims, charts, studies and product detail.{' '}
        <span className="text-navy" data-id="element-90" data-mp="6q26wvvd3bcu">Snakker adds another possibility — turn the benefit into something the HCP can do.</span>
      </p>

      <p className="mt-10 text-sm text-navy/45" data-id="element-91" data-mp="1o4i7m46zoci">A short interaction can let the HCP</p>
      <ol className="mt-3 grid overflow-hidden rounded-xl border border-navy/10 sm:grid-cols-5" data-id="element-92" data-mp="3tt6wn5yejuqu">
        {snakkerVerbs.map((v, i) => <li key={v} className={`px-4 py-4 text-base leading-snug text-navy ${i > 0 ? 'border-t border-navy/10 sm:border-l sm:border-t-0' : ''}`} data-id="element-93" data-mp="2iel06lek6w5f" data-mpi={i}>
            {v}
          </li>)}
      </ol>

      <p className="mt-10 max-w-2xl text-2xl leading-snug tracking-[-0.01em] text-navy" data-id="element-94" data-mp="xhbmmksnquvd">
        The result is a product story that is easier to engage with — and easier to remember.
      </p>
    </div>;
}